import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePaginatedPaymentSchemes } from '../../../../../hooks/payment-schemes/usePaginatedSchemes';
import { Select } from '../../../../../utils/components/hoc-components';

interface PaymentSchemeSelectProps {
  disabledCurrentYear?: boolean;
  disabledNextYear?: boolean;
}

export function PaymentSchemeSelect({
  disabledCurrentYear = false,
  disabledNextYear = false,
}: PaymentSchemeSelectProps) {
  const { t } = useTranslation();

  const searchParams = useMemo(
    () => new URLSearchParams({ status: '0', page: '1', size: '9999' }),
    []
  );

  const { data: paymentSchemes, isLoading } =
    usePaginatedPaymentSchemes(searchParams);

  const schemesOptions = useMemo(
    () =>
      paymentSchemes?.result.map((p) => ({
        value: p.id,
        label: `${p.name}`,
      })) ?? [],
    [paymentSchemes]
  );

  return (
    <>
      <div className="mb-6">
        <Select
          name="paymentSchemeTemplateId"
          options={schemesOptions}
          disabled={disabledCurrentYear || isLoading}
          placeholder={
            t('USERS.DRAWER.PLACEHOLDERS.PAYMENT_SCHEME_CURRENT_YEAR') ?? ''
          }
          label={t('USERS.DRAWER.LABELS.PAYMENT_SCHEME_CURRENT_YEAR') ?? ''}
          searchable={true}
        />
      </div>
      <div className="mb-6">
        <Select
          name="nextYearPaymentSchemeTemplateId"
          options={schemesOptions}
          disabled={disabledNextYear || isLoading}
          placeholder={
            t('USERS.DRAWER.PLACEHOLDERS.PAYMENT_SCHEME_NEXT_YEAR') ?? ''
          }
          label={t('USERS.DRAWER.LABELS.PAYMENT_SCHEME_NEXT_YEAR') ?? ''}
          searchable={true}
        />
      </div>
    </>
  );
}
